import { createAction } from 'redux-actions';

export const GET_PAYMENT_METHODS_REQUEST = createAction('GET_PAYMENT_METHODS_REQUEST');
export const GET_PAYMENT_METHODS_FAILURE = createAction('GET_PAYMENT_METHODS_FAILURE');
export const GET_PAYMENT_METHODS_SUCCESS = createAction('GET_PAYMENT_METHODS_SUCCESS');
